import TabNavItem from "../components/TabNavItem";
import TabContent from "../components/TabContent";
import { Link } from "react-router-dom";
import "../components/Tabs.css";
import React, { useState } from "react";

import p1 from "./img/레디프리산.png";
//import p2 from "./img/이노프리.jpg";
import p2 from "./img/이노쿨산_.jpg";
import p3 from "./img/제로프리.jpg";
import EndoRapid from "./img/EndoRapid.png";
import Acecide from "./img/Acecide.png";


import SubHeader from "../components/subHeader2";
import i18next from "../config/lang/i18next";

const options = ["OER-AW", "b", "c"];

const Software = () => {
  const [activeTab, setActiveTab] = useState("OER-AW");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("OER-AW");

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    console.log(selectedOption);
  };
  return (
    <div className="wrapper">
      <style>
        {`
      .Tabs2 ul.nav {
        width: 40%;
        min-width:unset;
      }
      .Tabs2 ul.nav li {
        width: 47%;
      }
      .pDesc .btns {
        width: 100%;
        display:flex;
        justify-content:center;
      }
      `}
      </style>
      <SubHeader />

      <div className="prod">
        <div className="">
          <div className="section_title">
            <h1 className="headerText">Pharmaceutical</h1>
          </div>

         
            
            <div className="device_wrap">

                <div style={{display:"flex"}}>
                  {/*}
                <Link className="pd_row banner_img" to="/device/d1">
                  <img
                    src={OEV321UH}
                    alt="ex1"
                  ></img>
                  <div class="hover_text">
                    <h3>OEV-321UH</h3>
                    <p>올림푸스 내시경 시스템에 최적화된 32인치 LCD 모니터</p>
                    <button>자세히 보기</button>
                  </div>
                </Link>
                  */}

<Link className="pd_row banner_img" to="/medicine/m1">
                  <img
                    src={p1}
                    alt="ex1"
                  ></img>

                  <div class="hover_text">
                    <h3>{i18next.t("m1")}</h3>
                    <p>
                    {i18next.t("m1_")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>
                <Link className="pd_row banner_img" to="/medicine/m2">
                  <img
                    src={p2}
                    alt="ex1"
                  ></img>
                  <div class="hover_text">
                    <h3>{i18next.t("m2")}</h3>
                    <p>
                    {i18next.t("m2_")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>
                </Link>
                
                <Link className="pd_row banner_img" to="/medicine/m3">
                  <img
                    src={p3}
                    alt="ex1"
                    style={{height:"100%"}}
                  ></img>

                  <div class="hover_text">
                    <h3>{i18next.t("m3")}</h3>
                    <p>
                    {i18next.t("m3_")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>

          

                </div>
              
                <div style={{display:"flex"}}>

                <Link className="pd_row banner_img" to="/medicine/m4">
                  <img
                    src={Acecide}
                    alt="ex1"
                  ></img>

                  <div class="hover_text">
                    <h3>{i18next.t("m4")}</h3>
                    <p>
                    {i18next.t("m4_")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>

                <Link className="pd_row banner_img" to="/medicine/m5">
                  <img
                    src={EndoRapid}
                    alt="ex1"
                  ></img>

                  <div class="hover_text">
                    <h3>{i18next.t("m5")}</h3>
                    <p>
                    {i18next.t("m5_")}
                    </p>
                    <button>{i18next.t("more")}</button>
                  </div>

                </Link>
                </div>

              
            </div>
        </div>
      </div>
    </div>
  );
};

export default Software;
